export default "__VITE_ASSET__BZtjOo5D__"